
import React from "react";

const Loader14 = ({ text = "In Progress" }) => {
  return (
    <div className="loader-wrapper">
      {/* three dots */}
      <span className="dot"></span>
      <span className="dot"></span>
      <span className="dot"></span>

      {/* text beside dots */}
      <span className="attesta-blue">{text}</span>

      <style>{`
        .loader-wrapper {
          display: flex;
          flex-direction: row; /* dots left, text right */
          align-items: center;
          gap: 0.6em;
          color: #16708c; /* brand colour */
        }

        .dot {
          width: 0.3em;
          height: 0.3em;
          border-radius: 50%;
          background: currentColor;
          animation: bounce 0.8s ease-in-out infinite;
        }

        .dot:nth-child(1) {
          animation-delay: 0s;
        }
        .dot:nth-child(2) {
          animation-delay: 0.2s;
        }
        .dot:nth-child(3) {
          animation-delay: 0.4s;
        }

        @keyframes bounce {
          0%, 80%, 100% {
            transform: translateY(0);
          }
          40% {
            transform: translateY(-6px);
          }
        }

        .loader-text {
          font-size: 12px;
          font-weight: 500;
        }
      `}</style>
    </div>
  );
};

export default Loader14;
